import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PropTypes from 'prop-types';

export default function BackButton({ className = '' }) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      className={`fixed top-20 left-6 z-40 flex items-center justify-center w-10 h-10 bg-white border-2 border-gray-300 rounded-full shadow-lg hover:bg-gray-100 hover:border-gray-400 transition-all duration-200 ${className}`}
      title="Go back"
    >
      <ArrowLeft size={20} className="text-gray-700" />
    </button>
  );
}
BackButton.propTypes = {
  className: PropTypes.string,
};
